import { PermissionContext } from 'src/app/shared/rpe/rpe-permissions.model';

export class SetEffectivePermissionsLoadStarted {
  static readonly type = '[UserEffectivePermissions] Load Started';
}

export class SetEffectivePermissionsSuccess {
  static readonly type = '[UserEffectivePermissions] Load Success';
  constructor(
    public userId: number,
    public permissionContexts: PermissionContext[]
  ) {}
}

export class SetEffectivePermissionsFailure {
  static readonly type = '[UserEffectivePermissions] Load Failure';
  constructor(public userId: number) {}
}

export class SetActivePermissionLocation {
  static readonly type = '[UserEffectivePermissions] Set Active Location';
  constructor(public locationId: number | null) {}
}

export class ClearEffectivePermissions {
  static readonly type = '[UserEffectivePermissions] Clear';
}
